export enum EndPoint {
  TW_ENDPOINT = 'TW_ENDPOINT',
  TW_AUTHENTICATED_ENDPOINT = 'TW_AUTHENTICATED_ENDPOINT',
  PPS_ENDPOINT = 'PPS_ENDPOINT',
  IMAGES_TW_ENDPOINT = 'IMAGES_TW_ENDPOINT',
  PPS_REST_ENDPOINT = 'PPS_REST_ENDPOINT',
}
